"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.slugify=e=>e.toString().normalize("NFD").replace(/[\u0300-\u036F]/g,"").toLowerCase().trim().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/_/g,"-").replace(/--+/g,"-").replace(/-$/g,"");
//# sourceMappingURL=slugify.js.map
